import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/orijinal-botoks-anlama-yontemleri-guvenli-urun-tespit-etme/page.tsx");
